import type { ReactElement, ReactNode } from "react";

export namespace PromptBig {
	export type Props = {
		image: ReactElement;
		title?: string;
		message?: ReactNode;
	};
}

export function PromptBig(props: PromptBig.Props) {
	return (
		<div className="m-auto h-full flex items-center justify-center px-32">
			<div className="flex gap-32">
				<div className="flex items-center justify-center">{props.image}</div>
				<div className="flex-col space-y-16">
					<div className="flex flex-col gap-40">
						<h1 className="text-2xl/heading h-[32px]">{props.title}</h1>
						<div className="text-lg h-[24px] space-y-16">
							<div className="flex flex-col gap-24">{props.message}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
